import dayjs from 'dayjs';
import { ISettings, IUserBase } from './components/backend/backendapi';
import { createPopper } from '@popperjs/core';

export type WindowType = Window & typeof globalThis & {
  application: {
    //things from _CommonPartial; for page specific add below
    baseUrl: string,
    loggedIn: boolean,
    media: any,
    permissions: {
      media: {
        deleteFolder: boolean,
        addFolder: boolean,
        delete: boolean,
        add: boolean,
      },
      activity: {
        activity: boolean,
      }
      cell: {
        mediaDelete: boolean,
      },
      duty: {
        printqr: boolean,
        isCellUpload: boolean,
        isDutyUpload: boolean,
        newTechArea: boolean,
        isDutyCellEdit: boolean,
      },
      kanban: {
        workflow: boolean,
        cardDelete: boolean,
        flowDelete: boolean,
        boardDelete: boolean,
        cardEdit: boolean,
        flowEdit: boolean,
        boardEdit: boolean,
        cardAttributeDefinitionEdit: boolean,
        allowTimeRecording: boolean,
        scripting: boolean,
        approval: boolean,
      },
      account: {
        isAccountShowMaxUsers: boolean;
      },
      testequipment: {
        archive: boolean,
        audit: boolean,
        edit: boolean,
        mediadelete: boolean,
      },
      survey: {
        approval: boolean;
        admin: boolean;
        group: {
          advanceRegistration: boolean,
          multipleSelection: boolean,
        },
        setResultEndDate: boolean,
      },
      visitorManagement: {
        approvalGroups: boolean,
        cockpit: boolean,
      },
      group: {
        admin: boolean;
      },
      map: {
        edit: boolean,
        delete: boolean,
        gps: {
          edit: boolean,
        }
      },
      misc: {
        fireProtection: boolean,
      },
      maintenance: {
        inventory: {
          bin: {
            bin: boolean,
            link: boolean,
          },
          stockTaking: {
            management: boolean,
          }
        }
      },
      settings: {
        general: boolean,
        notifications: boolean,
        localization: boolean,
      },
      productQualityTests: {
        archive: boolean,
        audit: boolean,
        edit: boolean,
        mediaDelete: boolean,
      },
    },
    kanban: {
      organigram: {
        wideAccounts: number[],
        orgcomponent: string,
        hidelines: boolean,
        boxstyle: string,
      },
      kanbanshowtime: boolean,
      user: IUserBase | undefined, // added by kanban pages, undefined in public view
    },
    check2: {
      isMaintenanceMode: boolean,
      isMap: boolean,
      RequestFlow: string,
      isInventory: boolean,
      isInventoryUpload: boolean,
      isOee: boolean,
      isDemo: boolean,
      isSysAdmin: boolean,
    },
    user: IUserBase,
    preview: any,
    pollingTime: number,
    isRefresh: boolean,

    culture: string,
    fnHome: () => void,

    locale: object,

    //via external js
    mediapicker: any, //revobase.mediapicker.js
    dropzone: any, //revobase.dropzone.js

    //xsrftoken
    xsrftoken: string, //from _CommonPartial //this may be broken, alice did not check if it is working

    //page specific things
    treeNodeId: number,
  },
}

declare var window: WindowType;

export function formatDate(d: Date): string {
  let locale = window.application.culture;
  switch (locale?.toLocaleLowerCase()) {
    case 'de':
      return dayjs(d).format('DD.MM.YYYY');
    default:
      return dayjs(d).format('YYYY-MM-DD');
  }
}

export function formatDateTime(d: Date): string {
  let locale = window.application.culture;
  switch (locale?.toLocaleLowerCase()) {
    case 'de':
      return dayjs(d).format('DD.MM.YYYY HH:mm');
    default:
      return dayjs(d).format('YYYY-MM-DD HH:mm');
  }
}

export function formatDateTimeSeconds(d: Date): string {
  let locale = window.application.culture;
  switch (locale?.toLocaleLowerCase()) {
    case 'de':
      return dayjs(d).format('DD.MM.YYYY HH:mm:ss');
    default:
      return dayjs(d).format('YYYY-MM-DD HH:mm:ss');
  }
}

export function formatTime(d: Date): string {
  return dayjs(d).format('HH:mm');
}

export function formatTimeSeconds(d: Date): string {
  return dayjs(d).format('HH:mm:ss');
}

export function formatDateForInput(d: Date): string {
  return dayjs(d).format('YYYY-MM-DD');
}

export function formatDateTimeForInput(d: Date): string {
  return dayjs(d).format('YYYY-MM-DDTHH:mm');
}

export function parseDateTimeFromInput(str: string): Date {
  return new Date(dayjs(str).valueOf());
}

export function formatDuration(seconds: number): string {
  let locale = window.application.culture;

  let hours = Math.floor(seconds / 60 / 60);
  let minutes = Math.floor((seconds % (60 * 60)) / 60);

  let ret = '';
  ret += hours + ':';
  ret += ('00' + minutes).slice(-2);
  return ret;
}

export function formatDurationSeconds(seconds: number): string {
  let locale = window.application.culture;

  let hours = Math.floor(seconds / 60 / 60);
  let minutes = Math.floor((seconds % (60 * 60)) / 60);
  let secs = Math.floor(seconds % 60);

  let ret = '';
  ret += hours + ':';
  ret += ('00' + minutes).slice(-2) + ':';
  ret += ('00' + secs).slice(-2);
  return ret;
}

export function fixISettings(): void {
  ISettings.fromJS = Settings.fromJS;
}

export class Settings extends ISettings {
  static fromJS = (data): ISettings => {
    data = typeof data === 'object' ? data : {};
    let result = new Settings();
    result.init(data);
    return result;
  };

  init(data?: any) {
    if (data) {
      for (var property in data) {
        (<any>this)[property] = (<any>data)[property];
      }
    }
  }
}

export function getPagePosition(element: HTMLElement): { x: number, y: number } {
  let rect = element.getBoundingClientRect();
  var x = rect.left;
  var y = rect.top;

  element = element.offsetParent! as HTMLElement;
  while (element) {
    x += element.scrollLeft;
    y += element.scrollTop;
    element = element.offsetParent! as HTMLElement;
  }

  return { x: x, y: y };
}

export function blobDownload(blob: any, filename: string) {
  var url = window.URL.createObjectURL(blob);
  var a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
}

export function unique<T>(arr: T[]): T[] {
  return arr.filter((value, index, self) => self.indexOf(value) === index);
}

export function emptyUUID(): string {
  return '00000000-0000-0000-0000-000000000000';
}

export function groupBy<K, V>(list: V[], selector: (V) => K): Map<K, V[]> {
  const map = new Map<K, V[]>();
  list.forEach(v => {
    const k = selector(v);
    if (!map.has(k)) {
      map.set(k, []);
    }
    map.get(k)!.push(v);
  });
  return map;
}

//see https://vue-select.org/guide/positioning.html#popper-js-integration
export function vSelectInModalWithPopper(dropdownList, component, { width }) {
  /**
   * We need to explicitly define the dropdown width since
   * it is usually inherited from the parent with CSS.
   */
  dropdownList.style.width = width;

  /**
   * Set zIndex higher that modal zIndex (1050)
   */
  dropdownList.style.zIndex = 1051;

  /**
   * Here we position the dropdownList relative to the $refs.toggle Element.
   *
   * The 'offset' modifier aligns the dropdown so that the $refs.toggle and
   * the dropdownList overlap by 1 pixel.
   *
   * The 'toggleClass' modifier adds a 'drop-up' class to the Vue Select
   * wrapper so that we can set some styles for when the dropdown is placed
   * above.
   */
  const popper = createPopper(component.$refs.toggle, dropdownList, {
    placement: 'bottom',
    modifiers: [
      {
        name: 'offset',
        options: {
          offset: [0, -1],
        },
      },
    ],
  });

  /**
   * To prevent memory leaks Popper needs to be destroyed.
   * If you return function, it will be called just before dropdown is removed from DOM.
   */
  return () => popper.destroy();
}

export function camelCase(str: string | null | undefined): string | null | undefined {
  if (!str?.length) {
    return str;
  }
  return str[0].toLocaleLowerCase() + str.slice(1);
}

export function getEnumValues(enu: unknown): { name: string, value: number }[] {
  const ret: string[] = [];
  for (let x in enu) {
    if (!x.match(/[0-9]+/)) {
      ret.push({ name: x, value: enu[x] });
    }
  }
  return ret;
}

export function useTrigger(trigger: unknown) {
  //intentional: nothing to do here
}

export function isValidEmail(email: string | null | undefined): boolean {
  return !!email?.trim() && email.indexOf('@') >= 0;
}

//decorattor, use as @aiGenerated
export function aiGenerated(...args: unknown[]): void {
}

export function isNoMail(email: string) {
  return email.endsWith('@nomail.com');
}
